module.exports = __webpack_public_path__ + "img/contact_manager.d59f508c.png";